export default __webpack_public_path__ + "static/media/share_facebook.2537eeb7.svg";